import request from "@/utils/request";
import dayjs from "dayjs";

// 获取日志列表
export function getList(query) {
  const { page, limit, endDate, startDate, ...params } = query;
  const whereKey = "sl";

  const payload = {
    page: {
      current: page,
      size: limit,
    },
    where: Object.entries(params).reduce(
      (acc, [key, value]) => (
        value ? (acc[`lk_${whereKey}.${key}`] = value) : null, acc
      ),
      {}
    ),
  };

  payload.where[`ge_${whereKey}.createTime`] = dayjs(startDate)
    .startOf("day")
    .format("YYYY-MM-DD HH:mm:ss");
  payload.where[`le_${whereKey}.createTime`] = dayjs(endDate)
    .endOf("day")
    .format("YYYY-MM-DD HH:mm:ss");

  payload.where[`desc_${whereKey}.createTime`] = 1;

  return request.post("/sys/log/getPage", payload).then(({ data, ...res }) => {
    const items = data.page.records?.map((item) => ({
      handle: item.operation,
      handle_by: item.username,
      handle_time: item.createTime,
      id: item.id,
      ip_address: item.ip,
      params: item.params,
    }));
    const total = data.page.total;
    return { ...res, data: { ...data, data: { items, total } } };
  });
}
